module.exports = __webpack_public_path__ + "img/fallaelectrica.d57bb1f2.png";